import {TaskConcreteInstanceSerializedType} from 'sweet-types';

// RE to capture the document slug from task html_url field
const slugRe = /sweetprocess\.com\/groups\/\w+\/(\w+)\//;

/**
 * Receives a task instance and reformat all included HTML URL to match the Guest app ones
 * That's required to make the guest-app breadcrumbs and step links to work
 */
export function reformatGuestTaskURLs(
  task: TaskConcreteInstanceSerializedType
): TaskConcreteInstanceSerializedType {
  // first we try to get slug from html_url, if it failed, (maybe we changed our URL structure)
  // use the document hashid as fallback
  const slug =
    slugRe.exec(task.html_url)?.[1] || task.template.assigned_object.hashid;

  task.html_url = getGuestTaskUrl(task.id, slug);

  if (task.assigned_version_content?.content_type === 'processversion') {
    for (const step of task.assigned_version_content.content) {
      if (step.type === 'processprocedure' && !step.deleted) {
        step.html_url = getGuestTaskUrl(task.id, slug, step.hashid);
      }
    }
  }

  return task;
}

const getGuestTaskUrl = (
  taskid: number,
  slug: string,
  hashid?: string
): string => `/tasks/guest/${slug}/${taskid}/${hashid ? `${hashid}/` : ''}`;
